<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="justify-content-start mb-5">
          <b-col cols="3" lg="2" xl="1">
            <b-button class="btn btnFilter" :disabled="activateSpinner"
             @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            </b-button>
          </b-col>
          <div class="text-xl-center">
            <b-button-group class="mt-3 mt-sm-0">
              <!-- <b-button :variant="tabName === 0 ? 'primary' : ''" @click="tabName = 0">{{ $t('common.security.ca') }}</b-button> -->
              <!-- <b-button :variant="tabName === 1 ? 'primary' : ''" @click="tabName = 1">{{ $t('common.security.certificates') }}</b-button> -->
              <!-- <b-button :variant="tabName === 2 ? 'primary' : ''" @click="tabName = 2">{{ $t('common.security.priv_ks') }}</b-button> -->
              <!-- <b-button :variant="tabName === 2 ? 'primary' : ''" @click="tabName = 2">{{ $t('common.security.pkcs') }}</b-button> -->
            </b-button-group>
          </div>
        </b-row>
        <b-tabs v-model="tabName" nav-class="d-none">
          <b-tab :title="$t('common.security.configurations')">
            <security-list typeList="configuration" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>
          </b-tab>
          <b-tab :title="$t('common.security.ca')" v-if="canSeeCA">
            <security-list typeList="ca" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>
          </b-tab>
          <b-tab :title="$t('common.security.certificates')" v-if="canSeeCertificates">
            <security-list typeList="certificate" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>
          </b-tab>
          <b-tab :title="$t('common.security.priv_ks')" v-if="canSeePrivateKeys">
            <security-list typeList="privatekey" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-list>
          </b-tab>
        </b-tabs>
      </div>
    </template>
  </page-outline>
</template>

<script>
import SecurityList from '@/pages/security/SecurityList.vue'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'SecurityPage',
  components: {
    'page-outline': PageOutline,
    'security-list': SecurityList
  },
  props: {
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    canSeeCA () {
      return this.$engine.rights.rightIs('ca_consulter', true)
    },
    canSeeCertificates () {
      return this.$engine.rights.rightIs('certificate_consulter', true)
    },
    canSeePrivateKeys () {
      return this.$engine.rights.rightIs('privatekey_consulter', true)
    }
  },
  watch: {
    tabName (val) {
      this.$engine.security.currentTab = val
    }
  },
  data () {
    return {
      activateSpinner: false,
      listTitle: '',
      refreshState: false,
      refreshKey: false,
      tabName: 0,
      tabValue: 0
    }
  },
  created () {
    this.listTitle = this.$i18n.t('Webheader.config_security')
    if (this.id !== '-1') {
      this.tabName = parseInt(this.id)
    }
  },
  methods: {
    onRefresh () {
      this.refreshKey = !this.refreshKey
    }
  }
}
</script>
